(function(){
  var idx=0, total=3, timer;
  function go(n){
    idx=(n+total)%total;
    document.getElementById('pgpTrack').style.transform='translateX(-'+idx+'00%)';
    document.querySelectorAll('.pgp-carousel-dot').forEach(function(d,i){
      d.classList.toggle('active',i===idx);
    });
  }
  function tick(){ go(idx+1); }
  function start(){ timer=setInterval(tick,4800); }
  function stop(){ clearInterval(timer); }
  window.pgpSlide=function(d){ stop(); go(idx+d); start(); };
  window.pgpGoTo=function(n){ stop(); go(n); start(); };
  // Pause on hover
  var el=document.querySelector('.pgp-carousel');
  if(el){ el.addEventListener('mouseenter',stop); el.addEventListener('mouseleave',start); }
  start();
})();